export const CULTURE_COOKIE_NAME = 'culture';
export const LANGUAGES = { EN: 'en', ES: 'es' };
export const DEFAULT_CULTURE = LANGUAGES.EN;
